(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const openedFacetPanel = document.querySelector('.facets__panel[data-auto-close-details][open]');
    if(event.target.tagName !== "SUMMARY" && 
      !event.target.classList.contains("facets__status") && 
      !openedFacetPanel){
      return;
    }

    if(openedFacetPanel){
      openedFacetPanel.removeAttribute('open'); 
      return;
    }
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );
    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();
